<template>
  <div>
    <b-card no-body>
      <b-card-header
        class="d-flex align-items-center"
        header-tag="header"
        role="tab"
        header-bg-variant="dark"
      >
        <div>
          <b>Account Representative Identity Check</b>
          <div class="text-muted">
            Verification of user's document
          </div>
        </div>

        <b-badge
          class="fixed-width-130 py-1 ml-auto"
          tag="div"
          :variant="getBadge(checklistItem.status)"
        >
          <div class="checklist-item__status">
            {{ checklistItemStatus }}
          </div>
        </b-badge>
      </b-card-header>
      
      <b-card-body
        v-if="checklistItemStatus !== 'Verified'"
        class="bg-light-dark"
      >
        <a
          :href="checklistItem.url"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>Click here to verify your identity.</strong>
        </a>
        <div>
          <small class="text-muted">
            This link will take you to a secure page where you can upload your documents.
          </small>
          <div><small><strong class="mr-1">Note:</strong>If the current one has expired, please refresh the page to get a new link.</small></div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
const statusMapping = {
  'NotRequested': 'In Progress',
  'Requested': 'Requested',
  'Received': 'Received',
  'Verified': 'Verified',
  'Failed': 'Failed',
  'Canceled': 'Canceled',
}

export default {
  name: 'VerificationIdentityChecklistItem',

  props: {
    checklistItem: {
      type: Object,
      required: true
    },
  },

  computed: {
    checklistItemStatus() {
      const status = this.checklistItem?.status ?? 'NotRequested'

      return statusMapping[status] 
    },
  },

  methods: {
    getBadge(status) {
      switch (status) {
      case 'Not Requested':
      case 'NotRequested':
      case 'Received':
        return 'warning'

      case 'Verified':
        return 'success'

      case 'Failed':
        return 'danger'

      default:
        return 'secondary'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.checklist-item__status {
  font-size: 0.8rem;
}
</style>